module.exports = __webpack_public_path__ + "img/side.e6146c8b.svg";